import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=8e3969ac&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3969ac')) {
      api.createRecord('8e3969ac', component.options)
    } else {
      api.reload('8e3969ac', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=8e3969ac&", function () {
      api.rerender('8e3969ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23W9Ka7D4pcPK/JS/comp/FavElement.vue"
export default component.exports